module.exports = __webpack_public_path__ + "officialStatic/img/logo8.b76a082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo8.png
// module id = kT/r
// module chunks = 0